export const flightAiRandomLoadingMessages = [
  // Common
  { message: "Extracting flight records", weight: 20 },
  { message: "Parsing departure times", weight: 20 },
  { message: "Reading airport codes", weight: 20 },
  { message: "Decoding airline identifiers", weight: 20 },
  { message: "Mapping flight routes", weight: 20 },
  { message: "Validating timestamp formats", weight: 20 },
  { message: "Cross-referencing IATA codes", weight: 20 },
  { message: "Parsing gate information", weight: 20 },
  { message: "Structuring passenger data", weight: 20 },
  { message: "Converting date formats", weight: 20 },
  { message: "Resolving timezone offsets", weight: 20 },
  { message: "Indexing flight segments", weight: 20 },
  { message: "Normalizing carrier codes", weight: 20 },
  { message: "Extracting layover details", weight: 20 },
  { message: "Parsing fare class codes", weight: 20 },
  { message: "Validating route sequences", weight: 20 },
  { message: "Compiling terminal data", weight: 20 },
  { message: "Resolving codeshare flights", weight: 20 },
  { message: "Structuring JSON schema", weight: 20 },
  { message: "Finalizing flight manifest", weight: 20 },

  // Rare
  { message: "Packing bags", weight: 10 },
  { message: "Resolving phantom flight duplicates", weight: 10 },
  { message: "Negotiating with legacy systems", weight: 10 },
  { message: "Deduplicating interlining segments", weight: 10 },

  // Easter egg
  { message: "Packing snacks", weight: 3 },
  { message: "Removing suspicious items from baggage", weight: 3 },
];